import React from "react";
import styled from "styled-components";
// Animations
import { motion } from "framer-motion";
import { pageAnimation, titleAnimation } from "../animation";
import { Hide } from "../styles";

const MenuStyle = styled(motion.section)`
  padding: 5rem;
  max-height: 100vh;
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: space-around;
  color: #f1ec0a;
  background-color: #ff1a1a;
  /* Kindel and iPad tablet  */
  @media only screen and (min-width: 540px) and (max-width: 820px) {
    padding: 5rem 2rem;
  }
  /* Mobile devices iPhone, Pixel */
  @media only screen and (min-width: 320px) and (max-width: 539px) {
    padding: 1.5rem;
    max-height: fit-content;
    height: 100%;
  }
`;

const MenuTitle = styled(motion.div)`
  width: 100%;
  h4 {
    color: #f1ec0a;
    font-size: 4rem;
  }
  p {
    color: #f1ec0a;
  }
  /* Kindel and iPad tablet  */
  @media only screen and (min-width: 540px) and (max-width: 820px) {
    h4 {
      font-size: 3.6rem;
    }
  }
  /* Mobile devices iPhone, Pixel */
  @media only screen and (min-width: 320px) and (max-width: 539px) {
    h4 {
      font-size: 2.5rem;
    }
    p {
      font-size: 1rem;
    }
  }
`;

const OurMenu = () => {
  return (
    <MenuStyle
      variants={pageAnimation}
      initial="hidden"
      animate="show"
      exit="exit"
    >
      <MenuTitle variants={titleAnimation}>
        <Hide>
          <motion.h4>Our Menu</motion.h4>
          <motion.p>
            At Burgred, our menu is a delicious blend of crowd-pleasers, offering something for every taste. Here's a look at what you can expect:
          </motion.p>
          <motion.p>
            <strong>Burgers:</strong><br />
            Whether you're a beef lover, prefer chicken, or enjoy fish, our burgers are crafted with premium, high-quality ingredients.
          </motion.p>
          <motion.p>
            <strong>Beef Burgers:</strong> Juicy, perfectly seasoned beef patties topped with a selection of cheeses (Gouda, Cheddar, or Camembert), fresh veggies, and homemade sauces.
          </motion.p>
          <motion.p>
            <strong>Chicken Burgers:</strong> Tender, flavorful chicken breast patties, seasoned and served with fresh toppings and your choice of sauce.
          </motion.p>
          <motion.p>
            <strong>Fish Burgers:</strong> Light, crispy fish fillets, paired with fresh vegetables and a tangy sauce for a flavorful bite.
          </motion.p>
          <motion.p>
            <strong>French Tacos:</strong><br />
            A French street food classic, our French tacos are packed with mouthwatering fillings and wrapped in a warm tortilla. Choose from a variety of delicious options, including juicy meats, and savory sauces that create an unforgettable taste experience.
          </motion.p>
          <motion.p>
            <strong>Fried French Tacos (Best Seller):</strong> Our fried French tacos are a fan favorite! Crispy on the outside and bursting with rich, flavorful fillings on the inside, these tacos are a must-try. Their unique combination of textures and flavors has made them the most popular item on our menu.
          </motion.p>
          <motion.p>
            <strong>Fried Chicken:</strong><br />
            For those craving something crispy and flavorful, our fried chicken is a true standout. Crispy on the outside, tender and juicy on the inside, our fried chicken is seasoned to perfection and cooked to golden-brown perfection.
          </motion.p>
          <motion.p>
            <strong>Salads:</strong><br />
            For a lighter, refreshing option, our fresh salads are loaded with vibrant vegetables and perfectly paired toppings. These healthy yet satisfying dishes are the perfect side to any main course or can stand alone as a meal.
          </motion.p>
        </Hide>
      </MenuTitle>
    </MenuStyle>
  );
};

export default OurMenu;
